import { BannerContainer, BannerText, BannerButton, DismissText } from './banner.styles';

const Banner = ({ onButtonClick, onDismiss }) => {
  return (
    <BannerContainer>
      <BannerText>
        No has completado tu proceso de registro. Selecciona cualquiera de las opciones:
      </BannerText>
      <div>
        <BannerButton onClick={onButtonClick}>Retomar</BannerButton>
        <DismissText onClick={onDismiss}>Descartar</DismissText>
      </div>
    </BannerContainer>
  );
};

export default Banner;
